import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type GetAllSettingsQueryVariables = {};


export type GetAllSettingsQuery = (
  { __typename?: 'Query' }
  & { globalSettings: Array<(
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, 'options' | 'type'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, 'type'>
    & { typeSettings: Array<(
      { __typename?: 'ProvingTypeSetting' }
      & Pick<Types.ProvingTypeSetting, 'type' | 'isActive'>
    )> }
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, 'value' | 'type'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, 'type'>
    & { file: (
      { __typename?: 'Blob' }
      & Pick<Types.Blob, 'uri' | 'name' | 'containerUri'>
    ) }
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, 'type'>
    & { globalMessage: Types.Maybe<(
      { __typename?: 'GlobalMessage' }
      & Pick<Types.GlobalMessage, 'message' | 'isActive'>
    )> }
  )> }
);

export type CreateOrUpdateGeneralSettingMutationVariables = {
  input: Types.GlobalSettingInput
};


export type CreateOrUpdateGeneralSettingMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateSetting: (
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, '_id'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id'>
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, '_id'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, '_id'>
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id'>
  ) }
);

export const GetAllSettingsDocument = gql`
    query getAllSettings {
  globalSettings {
    type
    ... on SingleValueSetting {
      value
    }
    ... on OptionsSetting {
      options
    }
    ... on ActiveProvingTypesSetting {
      typeSettings {
        type
        isActive
      }
    }
    ... on FileSetting {
      file {
        uri
        name
        containerUri
      }
    }
    ... on GlobalMessageSetting {
      globalMessage {
        message
        isActive
      }
    }
  }
}
    `;

    export function useGetAllSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllSettingsQuery, GetAllSettingsQueryVariables>) {
      return ApolloReactHooks.useQuery<GetAllSettingsQuery, GetAllSettingsQueryVariables>(GetAllSettingsDocument, baseOptions);
    };
      export function useGetAllSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllSettingsQuery, GetAllSettingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<GetAllSettingsQuery, GetAllSettingsQueryVariables>(GetAllSettingsDocument, baseOptions);
      };
      
export type GetAllSettingsQueryHookResult = ReturnType<typeof useGetAllSettingsQuery>;
export type GetAllSettingsQueryResult = ApolloReactCommon.QueryResult<GetAllSettingsQuery, GetAllSettingsQueryVariables>;
export const CreateOrUpdateGeneralSettingDocument = gql`
    mutation createOrUpdateGeneralSetting($input: GlobalSettingInput!) {
  createOrUpdateSetting(input: $input) {
    _id
  }
}
    `;
export type CreateOrUpdateGeneralSettingMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateGeneralSettingMutation, CreateOrUpdateGeneralSettingMutationVariables>;

    export function useCreateOrUpdateGeneralSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateGeneralSettingMutation, CreateOrUpdateGeneralSettingMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateOrUpdateGeneralSettingMutation, CreateOrUpdateGeneralSettingMutationVariables>(CreateOrUpdateGeneralSettingDocument, baseOptions);
    };
export type CreateOrUpdateGeneralSettingMutationHookResult = ReturnType<typeof useCreateOrUpdateGeneralSettingMutation>;
export type CreateOrUpdateGeneralSettingMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateGeneralSettingMutation>;
export type CreateOrUpdateGeneralSettingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateGeneralSettingMutation, CreateOrUpdateGeneralSettingMutationVariables>;